module.exports = __webpack_public_path__ + "assets/img/weixin-4a7c1f6b.png";